import { render, staticRenderFns } from "./product-hero.vue?vue&type=template&id=34f51260&"
import script from "./product-hero.vue?vue&type=script&lang=js&"
export * from "./product-hero.vue?vue&type=script&lang=js&"
import style0 from "./product-hero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default,IconPreview: require('/usr/src/app/components/icons/icon-preview.vue').default,TrustpilotStars: require('/usr/src/app/components/common-sections/trustpilot-stars.vue').default})
